import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { userSigInAction } from "../redux/slices/user/userSignInSlice";
import {
  hasActiveWebSession,
  invokeNativeAppLogout,
  isIosApp,
  isNativeAppWebView,
} from "../components/helpers/utils";

const NATIVE_HANDOFF_TIMEOUT_MS = 6000;

const UnauthenticatedRedirect = () => {
  const isNativeApp = isNativeAppWebView() || isIosApp();
  const [handoffFailed, setHandoffFailed] = useState(false);

  useEffect(() => {
    if (!isNativeApp) {
      return undefined;
    }

    let cancelled = false;
    const timers = [];

    const fallBackToWebLogin = () => {
      if (!cancelled) {
        setHandoffFailed(true);
      }
    };

    // A bridge message that never lands used to leave the WebView on the handoff
    // text with no way out. Web /login is a safe backstop — the native
    // login-route guard reads that route as a session handoff as well.
    const handOff = () => {
      if (invokeNativeAppLogout()) {
        timers.push(
          window.setTimeout(fallBackToWebLogin, NATIVE_HANDOFF_TIMEOUT_MS),
        );
        return;
      }

      fallBackToWebLogin();
    };

    // Hand off to native Login once the shell has finished bootstrapping.
    // The previous check inverted this and only called logout when the flag was
    // false — after a normal session that flag stays true, so sign-out left
    // users stuck on "Returning to sign in…".
    if (window.__EP_NATIVE_SESSION_READY__) {
      handOff();
    } else {
      // Bootstrap may still be writing auth into localStorage; wait briefly
      // before ejecting so a cold start does not race the inject.
      timers.push(
        window.setTimeout(() => {
          if (!hasActiveWebSession()) {
            handOff();
          }
        }, 2000),
      );
    }

    return () => {
      cancelled = true;
      timers.forEach((timer) => window.clearTimeout(timer));
    };
  }, [isNativeApp]);

  if (isNativeApp && !handoffFailed) {
    // Keep a visible handoff state so logout never looks like a dead app while
    // the native shell takes over.
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          color: "#0f1b3d",
          background: "#fff",
          textAlign: "center",
        }}>
        Returning to sign in…
      </div>
    );
  }

  return <Navigate to="/login" />;
};

const RouteProtection = ({ children, pageAccess, isIOS = null }) => {
  let isAutheticated;
  const dispatch = useDispatch();

  try {
    const user = localStorage.getItem("authorised");
    const authToken = localStorage.getItem("authToken");
    console.log(user?.length === 0, "YY token==>", user);
    if (
      user === "true" ||
      (authToken && authToken !== "null" && authToken !== "undefined")
    ) {
      isAutheticated = true;
    } else {
      isAutheticated = false;
    }

    // for professional users to login from mobile APP
    let iosCode = "";
    if (isIOS === "ios" || isIOS === "android") {
      let cookieValue = document.cookie;
      // iosCode = source?.[2];
      iosCode = cookieValue?.replace(
        /(?:(?:^|.*;\s*)professioanlCookie\s*\=\s*([^;]*).*$)|^.*$/,
        "$1",
      );
      localStorage.setItem("preference", true);
      localStorage.setItem("isIos", true);
      if (iosCode) {
        dispatch(
          userSigInAction?.fetchUserData(JSON.parse(window.atob(iosCode))),
        );
        console.log("IOS response ==>", JSON.parse(window.atob(iosCode)));
        isAutheticated = true;
      } else {
        isAutheticated = false;
      }
    }
    console.log("YY isAutheticated token==>>", isAutheticated);
  } catch (error) {
    isAutheticated = false;
  }

  return (
    <React.Fragment>
      {isAutheticated ? children : <UnauthenticatedRedirect />}
    </React.Fragment>
  );
};

export default RouteProtection;
